<div class="park-info" *ngIf="parks.length">
  <h4 class="park-info-title">Info de Parques</h4>

  <div class="park-info-grid">
    <article class="park-info-card" *ngFor="let p of parks; trackBy: trackByKey">
      <div class="park-info-media">
        <img class="park-info-img" [src]="basePath + p.key + '.jpg'" alt="{{ p.name }}" loading="lazy">
        <img class="park-info-badge" [src]="basePath + p.key + '-badge.png'" alt="" aria-hidden="true">
      </div>
      <div class="park-info-body">
        <h5 class="park-info-name">{{ p.name }}</h5>
        <p class="park-info-hours">{{ p.hours }}</p>
        <p class="park-info-desc" [class.expanded]="expanded[p.key]">
          {{ p.description }}
        </p>
        <button type="button" class="park-info-more" (click)="toggle(p.key)">
          {{ expanded[p.key] ? 'Ver Menos' : '... Ver Más' }}
        </button>
      </div>
    </article>
  </div>
</div>
